import { render, staticRenderFns } from "./Concessionaires.vue?vue&type=template&id=2aa31e8a&lang=pug&"
import script from "./Concessionaires.vue?vue&type=script&lang=ts&"
export * from "./Concessionaires.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports